import React from "react";
import "./A2Benefits.css";

const A2BenefitsHead = () => {
  return (
    <div className="lvlBenefitsHead">
      <h2>
        Benefits of A2 Level German Course at <span>Prizma Academy</span>
      </h2>
      {/* <p>
        Elevate your German proficiency with our B1 Level German Course. Here's
        how it benefits you:
      </p> */}
    </div>
  );
};

export default A2BenefitsHead;
